import React, { useEffect } from "react";
import API from "@unisearch/helpers/api";
import { useRouter } from "next/router";
import { LayoutMain } from "@unisearch/theme/layout";
import {
  LeadTemplateDefault,
  LeadTemplateElearning,
  LeadTemplateWebinar,
} from "@modules/lead/templates";
import LeadTemplateContact from "@modules/lead/templates/contact";

const Counselling = ({ pageData, lead_page }) => {
  const router = useRouter();
  useEffect(() => {
    if (!pageData || pageData?.template == "popup") {
      router.push("/404");
    }
  }, [router, pageData]);

  return (
    <LayoutMain
      title={pageData?.pageName}
      metaImage={pageData?.featureImageSrc}
      metaTitle={pageData?.pageName}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/lead/${lead_page}`}
    >
      {pageData && pageData?.template == "default" && (
        <LeadTemplateDefault pageData={pageData} />
      )}
      {pageData && pageData?.template == "contact" && (
        <LeadTemplateContact pageData={pageData} />
      )}
      {pageData && pageData?.template == "elearn" && (
        <LeadTemplateElearning pageData={pageData} />
      )}
      {pageData && pageData?.template == "webinar" && (
        <LeadTemplateWebinar pageData={pageData} />
      )}
    </LayoutMain>
  );
};

export default Counselling;

export async function getServerSideProps({ query }) {
  const { lead_page } = query;
  let props = {
    pageData: "",
    lead_page,
  };
  try {
    await API.get(`public/lead-contact-form/pages/${query?.lead_page}`).then(
      (resp) => {
        if (resp && resp?.data && !resp.error && resp.statusCode != 500) {
          props.pageData = resp?.data;
        }
      }
    );
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
